export enum DealerCampaignType {
    SERVICE = 'service',
    BUSINESS = 'business',
    PRIVATE = 'private',
    THEME_TILES = 'themeTiles',
}

export const DealerCampaignTypeList = [
    DealerCampaignType.SERVICE,
    DealerCampaignType.BUSINESS,
    DealerCampaignType.PRIVATE,
    DealerCampaignType.THEME_TILES,
] as const;

export const DealerCampaignTypeLabels = {
    [DealerCampaignType.SERVICE]: 'Service',
    [DealerCampaignType.BUSINESS]: 'Geschäftskunden',
    [DealerCampaignType.PRIVATE]: 'Privatkunden',
    [DealerCampaignType.THEME_TILES]: 'Themen',
} as const;

export enum DealerCampaignContentModuleType {
    IMAGE_TEXT = 'image-text',
    TEASER = 'teaser',
    LEASING_OFFER = 'leasing-offer',
    CASH_PRICE_OFFER = 'cash-price-offer',
    FINANCE_OFFER = 'finance-offer',
}

export const DealerCampaignContentModuleTypeList = [
    DealerCampaignContentModuleType.IMAGE_TEXT,
    DealerCampaignContentModuleType.TEASER,
    DealerCampaignContentModuleType.LEASING_OFFER,
    DealerCampaignContentModuleType.CASH_PRICE_OFFER,
    DealerCampaignContentModuleType.FINANCE_OFFER,
] as const;

export const DealerCampaignContentModuleTypeLabels = {
    [DealerCampaignContentModuleType.IMAGE_TEXT]: 'Bild Text - volle Breite',
    [DealerCampaignContentModuleType.TEASER]: 'Ankündigungsreihe',
    [DealerCampaignContentModuleType.LEASING_OFFER]: 'Leasingangebot',
    [DealerCampaignContentModuleType.CASH_PRICE_OFFER]: 'Barpreisangebot',
    [DealerCampaignContentModuleType.FINANCE_OFFER]: 'Finanzierungsangebot',
} as const;

export enum DealerCampaignLeaserOfferFootnoteType {
    PK_1 = 'pk-1',
    GK_1 = 'gk-1',
    PK_2 = 'pk-2',
    GK_2 = 'gk-2',
}

export enum DealerCampaignFinanceOfferFootnoteType {
    PK_1_H = 'pk-1-hyundai',
    //GK_2_H = 'gk-2-hyundai',
    //PK_1_A = 'pk-1-allane',
    //GK_2_A = 'gk-2-allane',
}

export enum DealerCampaignCashOfferFootnoteType {
    PK_1 = 'pk-1',
    //GK_2 = 'gk-2',
}

export const DealerCampaignLeaserOfferFootnoteTypeList = [
    DealerCampaignLeaserOfferFootnoteType.PK_1,
    DealerCampaignLeaserOfferFootnoteType.GK_1,
    DealerCampaignLeaserOfferFootnoteType.PK_2,
    DealerCampaignLeaserOfferFootnoteType.GK_2,
] as const;

export const DealerCampaignFinanceOfferFootnoteTypeList = [
    DealerCampaignFinanceOfferFootnoteType.PK_1_H,
    // DealerCampaignFinanceOfferFootnoteType.GK_2_H,
    // DealerCampaignFinanceOfferFootnoteType.PK_1_A,
    // DealerCampaignFinanceOfferFootnoteType.GK_2_A,
] as const;

export const DealerCampaignCashOfferFootnoteTypeList = [
    DealerCampaignCashOfferFootnoteType.PK_1,
    // DealerCampaignCashOfferFootnoteType.GK_2,
] as const;

export const DealerCampaignLeaserOfferFootnoteTypeLabels = {
    [DealerCampaignLeaserOfferFootnoteType.PK_1]:
        'Hyundai Capital Bank Europe GmbH Leasingangebot Privatkunden exkl. Überführungs- und Zulassungskosten',
    [DealerCampaignLeaserOfferFootnoteType.GK_1]:
        'Hyundai Capital Bank Europe GmbH Leasingangebot Geschäftskunden exkl. Überführungs- und Zulassungskosten',
    [DealerCampaignLeaserOfferFootnoteType.PK_2]:
        'Allane SE Leasingangebot Privatkunden exkl. Überführungs- und Zulassungskosten',
    [DealerCampaignLeaserOfferFootnoteType.GK_2]:
        'Allane SE Leasingangebot Geschäftskunden exkl. Überführungs- und Zulassungskosten',
};

export const DealerCampaignFinanceOfferFootnoteTypeLabels = {
    [DealerCampaignFinanceOfferFootnoteType.PK_1_H]: 'Finanzierungsangebot exkl. Überführungs- und Zulassungskosten',

    /* @Reviewer #### Das untere wird zu 99.99 % bald benötigt ####

    [DealerCampaignFinanceOfferFootnoteType.GK_2_H]:
        'Leasingangebot Geschäftskunden exkl. Überführungs- und Zulassungskosten (Hyundai Finance)',
    [DealerCampaignFinanceOfferFootnoteType.PK_1_A]:
        'Leasingangebot Privatkunden exkl. Überführungs- und Zulassungskosten (Allane Bank)',
    [DealerCampaignFinanceOfferFootnoteType.GK_2_A]:
        'Leasingangebot Geschäftskunden exkl. Überführungs- und Zulassungskosten (Allane Bank)',
        */
};

export const DealerCampaignCashOfferFootnoteTypeLabels = {
    [DealerCampaignCashOfferFootnoteType.PK_1]: 'Barpreisangebot',
    // [DealerCampaignCashOfferFootnoteType.GK_2]: 'Barpreisangebot Geschäftskunden exkl. Überführungs- und Zulassungskosten',
};

export interface ThemeTileCampaign {
    type: DealerCampaignType;
    teaserImage: string;
    id: number;
    createDate: string | null;
    slug: string;
    startDate: string;
    endDate: string;
    teaserHeadline: string;
}

export interface DealerCampaignContentModule {
    type: DealerCampaignContentModuleType;
    id: number;
    createDate: string | null;
    userId: string;
    campaignId: number;
    headline: string | null;
    sorting: number;
    campaign: Campaign;
}

interface Campaign {
    name: string;
    type: DealerCampaignType;
    id: number;
    createDate: string | null;
    userId: string;
    dealerId: string;
    slug: string;
    startDate: string;
    endDate: string;
    teaserHeadline: string;
    teaserImage: string;
    deleted: boolean | null;
}
